// import { useEffect, useState } from "react";
// import { Table, Spinner, Button, Input, Form, FormGroup, Label } from "reactstrap";
// import axiosInstance from "../../Request";
// import { URL } from "../../api";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const PIFReporting = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [filterType, setFilterType] = useState("customerId");
//   const [filterValue, setFilterValue] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const [y, m, d] = dateString.split("-");
//     return `${d}-${m}-${y}`;
//   };

//   const fetchPIFReport = async (filters = {}) => {
//     setLoading(true);
//     try {
//       const params = new URLSearchParams(filters).toString();
//       const url = `${URL.REPORTING_PIF}${params ? `?${params}` : ""}`;
//       const response = await axiosInstance.get(url);
//       setRows(response.data || []);
//     } catch (err) {
//       console.error("Error fetching PIF data:", err);
//       setRows([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPIFReport({});
//   }, []);

//   const handleSearch = (e) => {
//     e.preventDefault();
//     const filters = {};
//     if (filterValue.trim()) filters[filterType] = filterValue.trim();

//     if (fromDate) filters.fromDate = formatDate(fromDate);
//     if (toDate) filters.toDate = formatDate(toDate);

//     fetchPIFReport(filters);
//   };

//   const exportToExcel = () => {
//     if (rows.length === 0) {
//       alert("No data available to export!");
//       return;
//     }
//     const ws = XLSX.utils.json_to_sheet(rows);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "PIF_Report");
//     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     saveAs(new Blob([excelBuffer], { type: "application/octet-stream" }), "PIF_Report.xlsx");
//   };

//   const totalEmiAmount = rows.reduce((sum, r) => sum + (r.emiAmount || 0), 0);
//   const totalPrincipal = rows.reduce((sum, r) => sum + (r.principal || 0), 0);
//   const totalInterest = rows.reduce((sum, r) => sum + (r.interest || 0), 0);
//   const totalOutstanding = rows.reduce((sum, r) => sum + (r.outstandingAmount || 0), 0);

//   const font12 = { fontSize: "10px" };
//   const inputSmStyle = { ...font12, height: "30px", padding: "2px 6px" };
//   const buttonSmStyle = { ...font12, padding: "4px 10px", height: "30px", lineHeight: "1" };
//   const currentLabel = filterType === "customerId" ? "Customer ID" : "Loan ID";

//   return (
//     <div style={font12}>
//       {/* Filter Form */}
//       <Form onSubmit={handleSearch} className="mb-3">
//         <div className="d-flex align-items-end flex-wrap" style={{ gap: "10px", overflowX: "auto" }}>
//           <FormGroup className="mb-0" style={{ minWidth: "130px" }}>
//             <Label className="mb-1 fw-bold" style={font12}>Filter Type</Label>
//             <Input
//               bsSize="sm"
//               type="select"
//               value={filterType}
//               onChange={(e) => setFilterType(e.target.value)}
//               style={inputSmStyle}
//             >
//               <option value="customerId">Customer ID</option>
//               <option value="loanId">Loan ID</option>
//             </Input>
//           </FormGroup>

//           <FormGroup className="mb-0" style={{ minWidth: "160px" }}>
//             <Label className="mb-1 fw-bold" style={font12}>{currentLabel}</Label>
//             <Input
//               bsSize="sm"
//               type="text"
//               value={filterValue}
//               onChange={(e) => setFilterValue(e.target.value)}
//               placeholder={`Enter ${currentLabel}`}
//               style={inputSmStyle}
//             />
//           </FormGroup>

//           <FormGroup className="mb-0" style={{ minWidth: "150px" }}>
//             <Label className="mb-1 fw-bold" style={font12}>From Date</Label>
//             <Input
//               bsSize="sm"
//               type="date"
//               value={fromDate}
//               onChange={(e) => setFromDate(e.target.value)}
//               style={inputSmStyle}
//             />
//           </FormGroup>

//           <FormGroup className="mb-0" style={{ minWidth: "150px" }}>
//             <Label className="mb-1 fw-bold" style={font12}>To Date</Label>
//             <Input
//               bsSize="sm"
//               type="date"
//               value={toDate}
//               onChange={(e) => setToDate(e.target.value)}
//               style={inputSmStyle}
//             />
//           </FormGroup>

//           <div className="d-flex mb-0" style={{ gap: "6px" }}>
//             <Button color="primary" type="submit" style={buttonSmStyle}>
//               Search
//             </Button>
//             <Button type="button" color="success" onClick={exportToExcel} style={buttonSmStyle}>
//               Export To Excel
//             </Button>
//           </div>
//         </div>
//       </Form>

//       {/* Table */}
//       {loading ? (
//         <div className="d-flex align-items-center mt-3" style={{ gap: 8 }}>
//           <Spinner size="sm" /> <span>Loading PIF report...</span>
//         </div>
//       ) : rows.length === 0 ? (
//         <p className="mt-3 text-danger">No data found!</p>
//       ) : (
//         <div style={{ overflowX: "auto" }}>
//           <Table bordered striped hover responsive size="sm" className="mt-3 mb-0">
//             <thead className="thead-light">
//               <tr>
//                 <th style={font12}>#</th>
//                 <th style={font12}>ID</th>
//                 <th style={font12}>Loan ID</th>
//                 <th style={font12}>Customer ID</th>
//                 <th style={font12}>EMI Date</th>
//                 <th style={font12}>EMI Number</th>
//                 <th style={font12}>EMI Amount (₹)</th>
//                 <th style={font12}>Principal (₹)</th>
//                 <th style={font12}>Interest (₹)</th>
//                 <th style={font12}>Outstanding Amount (₹)</th>
//                 <th style={font12}>Outstanding Principal (₹)</th>
//                 <th style={font12}>Outstanding Interest (₹)</th>
//                 <th style={font12}>EMI Status</th>
//                 <th style={font12}>DPD</th>
//                 <th style={font12}>Create Date</th>
//                 <th style={font12}>Update Date</th>
//                 <th style={font12}>Is Delete</th>
//               </tr>
//             </thead>
//             <tbody>
//               {rows.map((r, idx) => (
//                 <tr key={r.id}>
//                   <td style={font12}>{idx + 1}</td>
//                   <td style={font12}>{r.id}</td>
//                   <td style={font12}>{r.loanId}</td>
//                   <td style={font12}>{r.customerId}</td>
//                   <td style={font12}>{r.emiDate}</td>
//                   <td style={font12}>{r.emiNumber}</td>
//                   <td style={font12}>{r.emiAmount?.toLocaleString()}</td>
//                   <td style={font12}>{r.principal?.toLocaleString()}</td>
//                   <td style={font12}>{r.interest?.toLocaleString()}</td>
//                   <td style={font12}>{r.outstandingAmount?.toLocaleString()}</td>
//                   <td style={font12}>{r.outstandingPrincipal?.toLocaleString()}</td>
//                   <td style={font12}>{r.outstandingInterest?.toLocaleString()}</td>
//                   <td style={font12}>{r.emiStatus}</td>
//                   <td style={font12}>{r.dpd || "-"}</td>
//                   <td style={font12}>{r.createDate}</td>
//                   <td style={font12}>{r.updateDate}</td>
//                   <td style={font12}>{r.isDelete}</td>
//                 </tr>
//               ))}
//               <tr style={{ fontWeight: "bold", backgroundColor: "#f1f3f5" }}>
//                 <td colSpan={6}>Totals</td>
//                 <td>{totalEmiAmount.toLocaleString()}</td>
//                 <td>{totalPrincipal.toLocaleString()}</td>
//                 <td>{totalInterest.toLocaleString()}</td>
//                 <td>{totalOutstanding.toLocaleString()}</td>
//                 <td colSpan={7}></td>
//               </tr>
//             </tbody>
//           </Table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PIFReporting;



// import { useEffect, useState } from "react";
// import { Table, Spinner, Button, Input, Form, FormGroup, Label } from "reactstrap";
// import axiosInstance from "../../Request";
// import { URL } from "../../api";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const PIFReporting = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Filter States
//   const [filterType, setFilterType] = useState("customerId");
//   const [filterValue, setFilterValue] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const rowsPerPage = 30; // Set to 30 rows per page
//   const [hasNextPage, setHasNextPage] = useState(false);
//   const [activeFilters, setActiveFilters] = useState({});

//   const fetchPIFReport = async (page = 1, filters = {}) => {
//     setLoading(true);
//     try {
//       const params = { ...filters };
//       params.page = page - 1; // Backend is zero-based
//       params.size = rowsPerPage;

//       const response = await axiosInstance.get(URL.REPORTING_PIF, { params });
      
//       const data = Array.isArray(response.data) ? response.data : [];
//       setRows(data);
//       setCurrentPage(page);
      
//       // If we received exactly 'rowsPerPage', assume there might be a next page
//       setHasNextPage(data.length === rowsPerPage);
//     } catch (err) {
//       console.error("Error fetching PIF data:", err);
//       setRows([]);
//       setHasNextPage(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPIFReport(1, {});
//   }, []);

//   const handleSearch = (e) => {
//     e.preventDefault();
//     const filters = {};
//     if (filterValue.trim()) filters[filterType] = filterValue.trim();
//     if (fromDate) filters.fromDate = fromDate;
//     if (toDate) filters.toDate = toDate;
    
//     setActiveFilters(filters);
//     fetchPIFReport(1, filters);
//   };

//   const exportToExcel = () => {
//     if (rows.length === 0) return alert("No data available to export!");
//     const ws = XLSX.utils.json_to_sheet(rows);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "PIF_Report");
//     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     saveAs(new Blob([excelBuffer], { type: "application/octet-stream" }), "PIF_Report.xlsx");
//   };

//   const font12 = { fontSize: "10px" };
//   const inputSmStyle = { ...font12, height: "30px", padding: "2px 6px" };
//   const buttonSmStyle = { ...font12, padding: "4px 10px", height: "30px", lineHeight: "1" };

//   return (
//     <div style={font12}>
//       <Form onSubmit={handleSearch} className="mb-3">
//         <div className="d-flex align-items-end flex-wrap" style={{ gap: "10px" }}>
//           <FormGroup className="mb-0">
//             <Label className="mb-1 fw-bold">Filter Type</Label>
//             <Input bsSize="sm" type="select" value={filterType} onChange={(e) => setFilterType(e.target.value)} style={inputSmStyle}>
//               <option value="customerId">Customer ID</option>
//               <option value="loanId">Loan ID</option>
//             </Input>
//           </FormGroup>

//           <FormGroup className="mb-0">
//             <Label className="mb-1 fw-bold">Enter ID</Label>
//             <Input bsSize="sm" type="text" value={filterValue} onChange={(e) => setFilterValue(e.target.value)} style={inputSmStyle} />
//           </FormGroup>

//           <FormGroup className="mb-0">
//             <Label className="mb-1 fw-bold">From Date</Label>
//             <Input bsSize="sm" type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={inputSmStyle} />
//           </FormGroup>

//           <FormGroup className="mb-0">
//             <Label className="mb-1 fw-bold">To Date</Label>
//             <Input bsSize="sm" type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={inputSmStyle} />
//           </FormGroup>

//           <div className="d-flex" style={{ gap: "6px" }}>
//             <Button color="primary" type="submit" style={buttonSmStyle}>Search</Button>
//             <Button color="success" type="button" onClick={exportToExcel} style={buttonSmStyle}>Export</Button>
//           </div>
//         </div>
//       </Form>

//       {loading ? (
//         <Spinner size="sm" />
//       ) : (
//         <>
//           <Table bordered striped hover responsive size="sm" className="mt-3">
//             <thead className="thead-light">
//               <tr>
//                 <th>#</th>
//                 <th>ID</th>
//                 <th>LOAN ID</th>
//                 <th>CUSTOMER ID</th>
//                 <th>EMI DATE</th>
//                 <th>EMI NO.</th>
//                 <th>EMI AMOUNT</th>
//                 <th>PRINCIPAL</th>
//                 <th>INTEREST</th>
//                 <th>OUTSTANDING</th>
//                 <th>DPD</th>
//                 <th>STATUS</th>
//               </tr>
//             </thead>
//             <tbody>
//               {rows.map((r, idx) => (
//                 <tr key={idx}>
//                   <td>{(currentPage - 1) * rowsPerPage + idx + 1}</td>
//                   <td>{r.id}</td>
//                   <td>{r.loan_id}</td>
//                   <td>{r.customer_id}</td>
//                   <td>{r.emi_date}</td>
//                   <td>{r.emi_number}</td>
//                   <td>{Number(r.emi_amount || 0).toLocaleString()}</td>
//                   <td>{Number(r.outstanding_principal || 0).toLocaleString()}</td>
//                   <td>{Number(r.outstanding_interest || 0).toLocaleString()}</td>
//                   <td>{Number(r.outstanding_amount || 0).toLocaleString()}</td>
//                   <td>{r.dpd || "0"}</td>
//                   <td>{r.emi_status_value}</td>
//                 </tr>
//               ))}
//               {rows.length === 0 && (
//                 <tr>
//                   <td colSpan="12" className="text-center text-muted">No data found.</td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>

//           {/* Pagination UI with Page Numbers 1, 2, 3... */}
//           <div className="d-flex justify-content-center mt-3">
//             <div className="d-flex align-items-center" style={{ gap: "5px" }}>
//               <Button
//                 color="outline-primary"
//                 size="sm"
//                 style={buttonSmStyle}
//                 onClick={() => fetchPIFReport(currentPage - 1, activeFilters)}
//                 disabled={currentPage === 1}
//               >
//                 Prev
//               </Button>

//               {/* Logic for Page Numbers 1, 2, 3... */}
//               {Array.from({ length: hasNextPage ? currentPage + 1 : currentPage }, (_, i) => {
//                 const pageNum = i + 1;
//                 // Shows current, previous, and next page buttons
//                 if (pageNum >= currentPage - 1 && pageNum <= currentPage + 1) {
//                   return (
//                     <Button
//                       key={pageNum}
//                       size="sm"
//                       style={buttonSmStyle}
//                       color={currentPage === pageNum ? "primary" : "outline-primary"}
//                       onClick={() => fetchPIFReport(pageNum, activeFilters)}
//                     >
//                       {pageNum}
//                     </Button>
//                   );
//                 }
//                 return null;
//               })}

//               <Button
//                 color="outline-primary"
//                 size="sm"
//                 style={buttonSmStyle}
//                 onClick={() => fetchPIFReport(currentPage + 1, activeFilters)}
//                 disabled={!hasNextPage}
//               >
//                 Next
//               </Button>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default PIFReporting;




import { useEffect, useState } from "react";
import { Table, Spinner, Button, Input, Form, FormGroup, Label, Alert } from "reactstrap";
import axiosInstance from "../../Request";
import { URL } from "../../api";

const PIFReporting = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false); // New state for Export loading

  // Filter States
  const [filterType, setFilterType] = useState("customerId");
  const [filterValue, setFilterValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 30; 
  const [hasNextPage, setHasNextPage] = useState(false);
  const [activeFilters, setActiveFilters] = useState({});

  const fetchPIFReport = async (page = 1, filters = {}) => {
    setLoading(true);
    try {
      const params = { ...filters };
      params.page = page - 1; 
      params.size = rowsPerPage;

      const response = await axiosInstance.get(URL.REPORTING_PIF, { params });
      const data = Array.isArray(response.data) ? response.data : [];
      setRows(data);
      setCurrentPage(page);
      setHasNextPage(data.length === rowsPerPage);
    } catch (err) {
      console.error("Error fetching PIF data:", err);
      setRows([]);
      setHasNextPage(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPIFReport(1, {});
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    const filters = {};
    if (filterValue.trim()) filters[filterType] = filterValue.trim();
    if (fromDate) filters.fromDate = fromDate;
    if (toDate) filters.toDate = toDate;
    
    setActiveFilters(filters);
    fetchPIFReport(1, filters);
  };

  // SECURE API EXPORT CALL (Authenticated & Scalable)
  const handleExport = async () => {
    if (rows.length === 0) return alert("No data available to export!");

    setExporting(true);
    try {
      const params = { 
        ...activeFilters, 
        export: true 
      };

      // Calls backend with Bearer Token and treats response as a File (Blob)
      const response = await axiosInstance.get(URL.REPORTING_PIF, {
        params,
        responseType: 'blob', 
      });

      // Create a URL for the downloaded blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Filename with timestamp
      link.setAttribute('download', `PIF_Report_${new Date().getTime()}.csv`);
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export failed:", err);
      alert("Export failed. Please check your connection or session.");
    } finally {
      setExporting(false);
    }
  };

  const font10 = { fontSize: "10px" };
  const inputSmStyle = { ...font10, height: "30px", padding: "2px 6px" };
  const buttonSmStyle = { ...font10, padding: "4px 10px", height: "30px", lineHeight: "1" };

  return (
    <div style={font10}>
      <Form onSubmit={handleSearch} className="mb-3">
        <div className="d-flex align-items-end flex-wrap" style={{ gap: "10px" }}>
          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">Filter Type</Label>
            <Input bsSize="sm" type="select" value={filterType} onChange={(e) => setFilterType(e.target.value)} style={inputSmStyle}>
              <option value="customerId">Customer ID</option>
              <option value="loanId">Loan ID</option>
            </Input>
          </FormGroup>

          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">Enter ID</Label>
            <Input bsSize="sm" type="text" value={filterValue} onChange={(e) => setFilterValue(e.target.value)} style={inputSmStyle} />
          </FormGroup>

          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">From Date</Label>
            <Input bsSize="sm" type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={inputSmStyle} />
          </FormGroup>

          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">To Date</Label>
            <Input bsSize="sm" type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={inputSmStyle} />
          </FormGroup>

          <div className="d-flex" style={{ gap: "6px" }}>
            <Button color="primary" type="submit" style={buttonSmStyle}>Search</Button>
            <Button 
                color="success" 
                type="button" 
                onClick={handleExport} 
                style={buttonSmStyle}
                disabled={exporting}
            >
              {exporting ? (
                <>
                  <Spinner size="sm" color="light" className="me-1" />
                  Wait...
                </>
              ) : (
                "Excel"
              )}
            </Button>
          </div>
        </div>
      </Form>

      {loading ? (
        <div className="text-center p-4"><Spinner size="sm" /> Loading PIF Summary...</div>
      ) : (
        <>
          <div style={{ overflowX: "auto" }}>
  <Table bordered striped hover responsive size="sm" className="mt-3 mb-0 text-nowrap">
    <thead className="thead-light">
      <tr>
        <th>#</th>
        <th>ID</th>
        <th>LOAN ID</th>
        <th>CUSTOMER ID</th>
        <th>Fintech Name</th>
        <th>EMI DATE</th>
        <th>EMI NO.</th>
        <th>EMI AMOUNT</th>
        <th>PENDING EMI AMOUNT</th> {/* Added */}
        <th>PRINCIPAL DUE</th>     {/* Added */}
        <th>OUTSTANDING PRINCIPAL</th>
        <th>OUTSTANDING INTEREST</th>
        <th>OUTSTANDING</th>
        <th>DPD</th>
        <th>STATUS</th>
      </tr>
    </thead>
    <tbody>
      {rows.length > 0 ? (
        rows.map((r, idx) => (
          <tr key={idx}>
            <td>{(currentPage - 1) * rowsPerPage + idx + 1}</td>
            <td>{r.id}</td>
            <td>{r.loan_id}</td>
            <td>{r.customer_id}</td>
            <td>{r.fintech_name || "N/A"}</td>
            <td>{r.emi_date}</td>
            <td>{r.emi_number}</td>
            <td>₹{Number(r.emi_amount || 0).toLocaleString()}</td>
            {/* Added Pending EMI Amount */}
            <td>₹{Number(r.pending_emi_amount || 0).toLocaleString()}</td>
            {/* Added Principal Due */}
            <td>₹{Number(r.principal_due || 0).toLocaleString()}</td>
            <td>₹{Number(r.outstanding_principal || 0).toLocaleString()}</td>
            <td>₹{Number(r.outstanding_interest || 0).toLocaleString()}</td>
            <td>₹{Number(r.outstanding_amount || 0).toLocaleString()}</td>
            <td>{r.dpd || "0"}</td>
            <td className="fw-bold">{r.emi_status_value}</td>
          </tr>
        ))
      ) : (
        <tr>
          {/* colSpan updated to 15 */}
          <td colSpan="15" className="text-center text-muted">No data found.</td>
        </tr>
      )}
    </tbody>
  </Table>
</div>
          {/* Pagination */}
          <div className="d-flex justify-content-center mt-3">
            <div className="d-flex align-items-center" style={{ gap: "5px" }}>
              <Button
                color="outline-primary"
                size="sm"
                style={buttonSmStyle}
                onClick={() => fetchPIFReport(currentPage - 1, activeFilters)}
                disabled={currentPage === 1}
              >
                Prev
              </Button>

              {Array.from({ length: hasNextPage ? currentPage + 1 : currentPage }, (_, i) => {
                const pageNum = i + 1;
                if (pageNum >= currentPage - 1 && pageNum <= currentPage + 1) {
                  return (
                    <Button
                      key={pageNum}
                      size="sm"
                      style={buttonSmStyle}
                      color={currentPage === pageNum ? "primary" : "outline-primary"}
                      onClick={() => fetchPIFReport(pageNum, activeFilters)}
                    >
                      {pageNum}
                    </Button>
                  );
                }
                return null;
              })}

              <Button
                color="outline-primary"
                size="sm"
                style={buttonSmStyle}
                onClick={() => fetchPIFReport(currentPage + 1, activeFilters)}
                disabled={!hasNextPage}
              >
                Next
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PIFReporting;